import { ReactNode } from 'react';

import { StyledTable } from './Table.styled';

type Props = {
  'data-qa-id'?: string;
  headings: Array<ReactNode>;
  trQaId?: string;
  data: Array<Array<ReactNode>> | Array<ReactNode>;
  initialIndex?: number;
};

export function Table({
  headings,
  data,
  trQaId,
  initialIndex = 0,
  ...props
}: Props) {
  return (
    <StyledTable
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <thead>
        <tr>
          {headings.map((heading, index) => (
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/no-array-index-key
            <th key={index}>{heading}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((row, rindex) => (
          <tr // eslint-disable-next-line react/no-array-index-key
            key={rindex}
            data-qa-id={trQaId}
            data-row-index={rindex + initialIndex}
          >
            {Array.isArray(row)
              ? row.map((cell, index) => (
                  <td // eslint-disable-next-line react/no-array-index-key
                    key={index}
                  >
                    {cell}
                  </td>
                ))
              : row}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
}
